import { handle_api_error } from "./errorHandler";
import axios from "axios";
import { CONST } from "CONST";

  const apiEnv = process.env.REACT_APP_ENV;
  const base = `https://api.${apiEnv}.nexus.ke`;

  const api_url          = `${base}/v1/api/web/v1/intermediary`;
  const base_url         = api_url;
  const file_url         = base;
  const file_upload_url  = `${base}/v2/fileserver/`;
  const api_url_v2       = `${base}/v2/api/v1`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Token": sessionStorage.getItem("token"),
      "accesstoken": sessionStorage.getItem("token"),
    },
  };

function register({ email, category, ira_code }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
        //  timeout:15000
      };

      const body = {
        resource: "registration",
        action: "add",
        data: {
          ira_code: ira_code,
          category: category,
          email: email,
        },
      };

      localStorage.setItem("REG_EMAIL", email);
      let response = await call_api(body, );
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function verify(token) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
        //  timeout:15000
      };

      const body = {
        resource: "registration",
        action: "validation",
        data: {
          email_token: token,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function login({ username, password }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
        //  timeout:15000
      };
      sessionStorage.clear();
      const body = {
        resource: "login",
        action: "login",
        data: {
          username: username,
          password: password,
          device_details: {
            device_type: "CHROME",
            device_category: "WEB",
            device_version: "V1",
            device_name: "CHROME",
            device_uuid: "1223455",
          },
        },
      };
      let response = await call_api(body, config);
      // sessionStorage.setItem("token", response.token);
     // console.log('tk',sessionStorage.getItem("token"));

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function submitCredentials(registration_setup_id, names, credentials) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
        //  timeout:15000
      };
      const body = {
        resource: "registration",
        action: "credential",
        data: {
          registration_setup_id: registration_setup_id,
          tnc: credentials.tnc,
          names: names,
          contact: credentials.contact,
          employee_ref: credentials.employee_ref,
          password: credentials.password,
          username: credentials.username,
        },
      };
      console.log("the body of submiit is", body);
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function check_kyc() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "intermediary",
        action: "details",
        data: {},
      };
      let response = await call_api(body, config);
      console.log("checking kyc response suc", response)
      return resolve(response);
    } catch (err) {
      console.log("checking kyc response er", err)
      return reject(err);
    }
  });
}

function verify_email(token) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
        // timeout:15000
      };
      const body = {
        resource: "registration",
        action: "validation",
        data: {
          email_token: token,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function reset(request_id, password) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
        // timeout:15000
      };
      const body = {
        resource: "forgot_password",
        action: "change",
        data: {
          password_change_request_id: request_id,
          password: password,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_intermediary_type() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "intermediary",
        action: "details",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_requests() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "profile",
        action: "requests",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function forgot_password({ username }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
        //  timeout:15000
      };
      sessionStorage.clear();
      const body = {
        resource: "forgot_password",
        action: "request",
        data: {
          username: username,
        },
      };
      let response = await call_api(body, config);
      // sessionStorage.setItem("token", response.token);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
// **************************Quotation Requests

function get_quotation_requests() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "my_quotation_requests",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}



function get_client_quotation_requests() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Token": sessionStorage.getItem("token"),
              "accesstoken": sessionStorage.getItem("token"),
            },
          };
      const body = {
          "service":{
          "name":"underwriting",
          "version":"v1"
          },
          "resource":{"name":"quotation","version":"v1"},
          "action":{"name":"listClientQuotationRequests","version":"v1"},
          "data":{}
      }
      let response = await call_api_v2(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}



function view_quotation_request(system_quotation_request_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "quotation_request_details",
        data: {
          system_quotation_request_ref: `quo-req/${system_quotation_request_ref}`,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function accept_quotation_request(system_quotation_request_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "accept",
        data: {
          system_quotation_request_ref: system_quotation_request_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function reject_quotation_request(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "reject",
        data: {
          system_quotation_request_ref: values.system_quotation_request_ref,
          rejection_remarks: values.rejection_remarks,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function fetch_risk_form(insurance_class_code) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "quotation_form",
        data: {
          insurance_class_code: insurance_class_code,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function post_risk_form({ system_quotation_request_ref, client_id, riskForm }) {
  return new Promise(async function (resolve, reject) {
    try {
      let riskValue = [];
      Object.entries(riskForm).forEach(([key, value]) => {
        let obj = {
          name: key,
          value: value,
        };
        riskValue.push(obj);
      });

      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "add_risk",
        data: {
          system_quotation_request_ref: system_quotation_request_ref,
          client_id: client_id,
          risk_form: riskValue,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function post_client_risk_form({ client_quotation_id, riskForm }) {
  return new Promise(async function (resolve, reject) {
    try {
      let riskValue = [];
      
      Object.entries(riskForm).forEach(([key, value]) => {
        let name;
        if (key === "sum_assured") {
          name = "SFF01804920";
        } else if (key === "registration_number") {
          name = "SSF00013724";
        } else {
          name = key; // Keep original key if no special rule applies
        }
      
        const obj = {
          name,
          value,
        };
        riskValue.push(obj);
      });
      console.log("values risk", riskValue)

      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotations",
        action: "add_guest_client_quotation_risk",
        data: {
          guest_client_quotation_id: client_quotation_id,
          risk_form: riskValue
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_recommendations(system_quotation_request_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "quotation_reccomendation",
        data: {
          system_quotation_request_ref: system_quotation_request_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function add_recommendations({
  product_id,
  quotation_req_ref,
  recommendation_remarks,
  recommendation_level,
  special_code,
  risk,
}) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "create_recommendation",
        data: {
          product_id: product_id,
          quotation_req_ref: quotation_req_ref,
          recommendation_remarks: recommendation_remarks,
          recommendation_level: recommendation_level,
          special_code: special_code,
          risks: risk,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function recommendation_details(system_quotation_request_recommendation_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "get_recommendation",
        data: {
          system_quotation_request_recommendation_ref:
            system_quotation_request_recommendation_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function manage_appointment(action, appointment_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
      };
      const body = {
        resource: "intermediaryAppointment",
        action: action === "accept" ? "approve_appointment" : "reject_appointment",
        data: { intermediary_appointment_id: appointment_id },
      };
      console.log("Payload being sent to API:", body); 
      
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function remove_recommendation(system_quotation_request) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "remove_recommendation",
        data: {
          system_quotation_request_recommendation_ref: system_quotation_request,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_risks(system_quotation_request_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "fetch_risks",
        data: {
          system_quotation_request_ref: `quo-req/${system_quotation_request_ref}`,
        },
      };

      console.log("Requesting risks with body:", body);

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      console.error("Error fetching risks:", err);
      return reject(err);
    }
  });
}
function risk_details(risk_system_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "get_risk_details_system_ref",
        data: {
          risk_system_ref: risk_system_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function risk_guest_details(risk_system_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "get_guest_client_quotaion_risk_details",
        data: {
          risk_system_ref: risk_system_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_special_codes() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "tokens",
        action: "list",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_product_benefits(product_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "product",
        action: "benefits",
        data: {
          product_id: product_id,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


function add_product_benefits({ ref, benefits }) {
  return new Promise(async function (resolve, reject) {
    try {
      benefits.map(async (benefit) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
          // timeout:15000
        };
        const body = {
          resource: "quotation_request",
          action: "add_benefit",
          data: {
            system_quotation_request_recommendation_ref: ref,
            product_benefit_id: benefit.value,
            free_limit: benefit.name,
          },
        };
        let response = await call_api(body, config);
        return resolve(response);
      });
    } catch (err) {
      return reject(err);
    }
  });
}

function add_client_product_benefits({ ref, benefits }) {
  return new Promise(async function (resolve, reject) {
    try {
      benefits.map(async (benefit) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
        };
        const body = {
          resource: "quotations",
          action: "add_guest_recommendation_benefit",
          data: {
            guest_client_recommendation_id: ref,
            product_benefit_id: benefit.value,
            free_limit: benefit.free_limit,
          },
        };
        let response = await call_api(body, config);
        return resolve(response);
      });
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_products_by_underwriter() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
      };
      const body = {
        resource: "quotations",
        action: "list_products_by_underwriter_id",
        data: {
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function add_risk_to_recommendation({ ref, risk_ref }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "add_risk_recommendation",
        data: {
          system_quotation_request_recommendation_ref: ref,
          risk_ref: risk_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function remove_product_benefits(ref, product_benefit_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "remove_benefit",
        data: {
          system_quotation_request_recommendation_ref: ref,
          product_benefit_id: product_benefit_id,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function send_quotation_request(system_quotation_request_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotation_request",
        action: "send_to_client",
        data: {
          system_quotation_request_ref: system_quotation_request_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

// End of quotation requests

function get_policies() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "policies",
        action: "list",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


function get_policy(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "policies",
        action: "intermediary_portfolio_details",
        data: {
          client_product_id: id
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function upload_individual_agent_kyc_details(individualInfo) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "profile",
        action: "update_kyc",
        data: {
          update: {
            // category: category,
            emails: individualInfo.email,
            description: individualInfo.description,
            intermediary_names:
              individualInfo.intermediary_fname +
              " " +
              individualInfo.intermediary_lname,
            address: `${
              individualInfo.address + "-" + individualInfo.postal_code
            }`,
            contacts: individualInfo.contact,
            kra_pin: individualInfo.kra_pin,
            identification_number: individualInfo.id_number,
          },
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function upload_company_agent_kyc_details(companyInfo) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "profile",
        action: "update_kyc",
        data: {
          update: {
            // category: category,
            emails: companyInfo.email,
            description: companyInfo.description,
            intermediary_names: companyInfo.intermediary_names,
            address: `${companyInfo.address + "-" + companyInfo.postal_code}`,
            contacts: companyInfo.contact,
            kra_pin: companyInfo.kra_pin,
            kra_certificate_file_path: companyInfo.kra_certificate_file_path,
            cr12_certificate_file_path: companyInfo.cr12_certificate_file_path,
            incorporation_certificate_file_path: companyInfo.incorporation_certificate_file_path,
            memo_of_association_file_path: companyInfo.memo_of_association_file_path,
          },
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function upload_directors(directors) {
  return new Promise(async function (resolve, reject) {
    try {
      directors.map(async (director) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
          // timeout:15000
        };
        let body = {
          resource: "profile",
          action: "add_director",
          data: {
            director: {
              names: director.name,
              email: director.email,
              title: director.title,
              type: director.type,
              residency: director.residency,
              contact: director.contact,
            },
          },
        };

        let response = await call_api(body, config);
        console.log("success uploading partners", response);
        return resolve(response);
      });
    } catch (err) {
      return reject(err);
    }
  });
}

const upload_company_logo = async (info) => {
  return new Promise(async function (resolve, reject) {
    const fmData = new FormData();
    try {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      let response = await call_api(fmData, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
};

function get_dashboard_summary() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      let body = {
        resource: "profile",
        action: "dashboard",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_professions() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      let body = {
        resource: "profile",
        action: "my_proffesion",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_professions_list() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      let body = {
        resource: "insurance",
        action: "subclass",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function update_professions(professions) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      let body = {
        resource: "profile",
        action: "update_profession",
        data: {
          profession: professions,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function set_location(lat, lng) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      let body = {
        resource: "profile",
        action: "update_location",
        data: {
          coordinates: [lat, lng],
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_underwriters_requests() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      let body = {
        resource: "underwritter",
        action: "active",
        data: {},
      };
      let response = await call_api(body, config);
      //console.log("u res", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function request_underwriter({ underwriter_name, remarks="Please add me as your preffered as your intermediary" }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      let body = {
        resource: "underwritter",
        action: "request",
        data: {
          underwritter_code: underwriter_name.value,
          remarks: remarks,
        },
      };
      let response = await call_api(body, config);
      console.log("Res",response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_subclass() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "subclass",
        action: "subclass",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_subclass_products(code) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };

      const body = {
        resource: "subclass",
        action: "sub_class_code_products",
        data: {
          sub_class_code: code,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_underwriter_products() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };

      const body = {
        resource: "subclass",
        action: "list_products_buy_underwriter_id",
        data: {
    
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_product_summary(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };

      const body = {
        resource: "product",
        action: "summary",
        data: {
          product_id: id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_all_quotations() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotations",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function view_a_quotation(quotation_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotations",
        action: "details",
        data: {
          client_quotation_id: quotation_id,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function create_quotation(request_id, product_id, reference) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "quotations",
        action: "create",
        data: {
          client_req_id: request_id,
          product_id: product_id,
          quotation_reference: reference,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_asset_requirements(product_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };

      const body = {
        resource: "product",
        action: "requirements",
        data: {
          product_id: product_id,
        },
      };
      console.log("the body issssss", body);
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function send_quotation(risk, benefits, client_quotation_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };

      const body = {
        resource: "quotations",
        action: "add_risk",
        data: {
          client_quotation_id: client_quotation_id,
          risk_details: {
            risk: risk,
            benefits: benefits,
          },
        },
      };
      console.log("THE BODY OF MAKING A QUOTE", body);

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_wallet_info() {
  // console.log("wallet info")
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"wallet","version":"v1"},
        "action":{"name":"fetchIntermediaryWallets","version":"v1"},
        "data":{}
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

// Fetch Account Transactions Function
function fetch_account_transactions(account_number) {
  return new Promise(async (resolve, reject) => {
    console.log(`Fetching transactions for account: ${account_number}`); // Log the account number

    try {
    const body = {
            "service":{
                "name":"entity",
                "version":"v1"
            },
            "resource":{
                "name":"wallet",
                "version":"v1"
            },
            "action":{
                "name":"fetchWalletTransactions",
                "version":"v1"
            },  
            "data":{
                    "accountNumber": account_number
                }
        };

      // Call the API
      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("API Response:", response); // Log the API response

  
      resolve(response); 
    } catch (err) {
      console.error("Error fetching account transactions:", err); // Log any errors
      reject(err); // Reject the promise if there is an error
    }
  });
}

function fetch_commission_account() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "commision",
        action: "accounts",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


//new flow 
function fetch_commissions() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "commision",
        action: "accounts",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


function get_transactions(account_number) {
  console.log("account no", account_number)
  return new Promise(async function (resolve, reject) {
    try {

      const body = {
        "service":{
            "name":"entity",
            "version":"v1"
        },
        "resource":{
            "name":"wallet",
            "version":"v1"
        },
        "action":{
            "name":"fetchWalletTransactions",
            "version":"v1"
        },  
        "data":{
                "accountNumber": account_number
            }
    };
      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_my_underwriters() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "underwritter",
        action: "my_underwrittes",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_claim_types(client_product_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "claim",
        action: "type",
        data: {
          client_product_id: client_product_id,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function fetch_poliy_claims(client_product_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "policies",
        action: "get_policy_claims",
        data: {
          client_product_id: client_product_id,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function view_policy(client_product_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "policies",
        action: "detail",
        data: {
          client_product_id: client_product_id,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_form(product_id, claim_code) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };

      const body = {
        resource: "claim",
        action: "form",
        data: {
          client_product_id: product_id,
          claim_type_code: claim_code,
          claim_category: "REPORT",
        },
      };
      console.log("the body to fetch form", body);
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_claim_form(product_id, claim_code) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };

      const body = {
        resource: "claim",
        action: "form",
        data: {
          client_product_id: product_id,
          claim_type_code: claim_code,
          claim_category: "CLAIM",
        },
      };
      console.log("the body to fetch form", body);
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function generate_claim_ref(client_product_id, client_id, claim_type) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "claim",
        action: "generate_claim_ref",
        data: {
          client_product_id: client_product_id,
          client_id: client_id,
          claim_category: "REPORT",
          claim_type: claim_type,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function report_claim(claimId, values) {
  return new Promise(async function (resolve, reject) {
    try {
      Object.entries(values).forEach(async ([key, value]) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
          // timeout:15000
        };

        const body = {
          resource: "claim",
          action: "make",
          data: {
            claim_id: claimId,
            field_code: `${key}`,
            value: `${value}`,
          },
        };

        let response = await call_api(body, config);
        return resolve(response);
      });
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_all_claims() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "claim",
        action: "list_all",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_claim_details(claimId) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "claim",
        action: "details",
        data: {
          claim_id: claimId,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function fetch_claim_summary(claimId) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        action: "claim_summary",
        data: {
          claim_id: claimId,
        },
        resource: "claim",
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function make_claim_form(claimId) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "claim",
        action: "claimform",
        data: {
          claim_id: claimId,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function upload_individual_claim_field(claimId, values) {
  return new Promise(async function (resolve, reject) {
    try {
      Object.entries(values).forEach(async ([key, value]) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
          // timeout:15000
        };

        const body = {
          resource: "claim",
          action: "make",
          data: {
            claim_id: claimId,
            field_code: `${key}`,
            value: `${value}`,
          },
        };

        let response = await call_api(body, config);
        return resolve(response);
      });
    } catch (err) {
      console.log("we cant do this");
      return reject(err);
    }
  });
}

function send_claim(claimId, clientId) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "claim",
        action: "request",
        data: {
          claim_id: claimId,
          client_id: clientId,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_notifications() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "notifications",
        action: "list",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function validate_reset_token(token) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "forgot_password",
        action: "validation",
        data: {
          email_token: token,
        },
      };
      console.log("the otp body is", body);

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function create_an_appointment({
  title,
  name,
  phone,
  description,
  time,
  date,
  email,
  underwriter,
}) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "intermediaryAppointment",
        action: "create_appointment",
        data: {
          appointment_date: date,
          appointment_time: time,
          appointment_subject: title,
          appointment_description: description,
          underwritter_id: parseInt(underwriter[0]?.value),
          client_details: {
            client_contact: phone,
            client_email: email,
            client_name: name,
          },
          from: "INTERMEDIARY",
          to: "CLIENT"
        },
      };

      console.log("body of appointment", body);

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_appointments() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "intermediaryAppointment",
        action: "list_intermediary_appointments",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_appointment_details(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "intermediaryAppointment",
        action: "get_appointment_details",
        data: {
          intermediary_appointment_id: id.queryKey[1],
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function close_appointment(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "intermediaryAppointment",
        action: "close_appointment",
        data: {
          intermediary_appointment_id: id,
          update: {
            appointment_closure_remarks: "Marked as Done",
          },
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function update_appointment_new_status(id) {
  console.log("updating appoitnment", id)
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "intermediaryAppointment",
        action: "update_is_new_appointment",
        data: {
          intermediary_appointment_id: id,
        },
      };

      let response = await call_api(body, config);
      console.log("updating appointment status===", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_usmg_roles() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "role",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function add_usmg_roles({ name, description, role_code }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "role",
        action: "add",
        data: {
          name: name,
          description: description,
          role_code: role_code,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_system_resources() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "system_resource",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_role_grants(role_code) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "role",
        action: "list_grants",
        data: {
          role_code: role_code,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function revoke_resource(resource_code, role_code) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "role",
        action: "revoke_resource",
        data: {
          resource_code: resource_code,
          role_code: role_code,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function grant_resource(role_code, resources) {
  return new Promise(async function (resolve, reject) {
    try {
      resources.map(async (item) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
          // timeout:15000
        };
        const body = {
          resource: "role",
          action: "grant_resource",
          data: {
            resource_code: item,
            role_code: role_code,
          },
        };

        let response = await call_api(body, config);
        return resolve(response);
      });
    } catch (err) {
      return reject(err);
    }
  });
}

function grant_permissions(grant_id, permissions) {
  return new Promise(async function (resolve, reject) {
    try {
      permissions.map(async (item) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
          // timeout:15000
        };
        const body = {
          resource: "role",
          action: "grant_permission",
          data: {
            grant_id: grant_id,
            permission: item,
          },
        };
        console.log("the body to send", body);

        let response = await call_api(body, config);
        return resolve(response);
      });
    } catch (err) {
      return reject(err);
    }
  });
}

function remove_permissions(grant_id, permission) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "role",
        action: "revoke_permission",
        data: {
          grant_id: grant_id,
          permission: permission,
        },
      };

      console.log("the body to send", body);

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function view_role_details(role_code) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "role",
        action: "get",
        data: {
          role_code: role_code,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function create_department({ name, code, description }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "department",
        action: "create",
        data: {
          department_code: code,
          department_name: name,
          department_description: description,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_departments() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "department",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function department_details(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "department",
        action: "get",
        data: {
          department_id: id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_security_context() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "security_context",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_users() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "user",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function create_user({
  ref,
  name,
  department,
  role,
  contact,
  email,
  username,
  security,
}) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "user",
        action: "create",
        data: {
          employee_ref: ref,
          names: name,
          department: department,
          role_code: role,
          contact: contact,
          email: email,
          username: username,
          security_context_code: security,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function view_user(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "user",
        action: "get",
        data: {
          user_id: id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_user_groups() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "user_group",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function create_user_group({ code, name, description }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "user_group",
        action: "create",
        data: {
          group_code: code,
          group_name: name,
          description: description,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_chat_groups() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "chat",
        action: "get_entity_chat_group",
        data: {
          entity: {
            entity_type: "INTERMEDIARY",
          },
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function create_chat_groups() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "chat",
        action: "create_chat_group",
        data: {},
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_user_details(group_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "user_group",
        action: "details",
        data: {
          group_id: group_id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function add_user_to_group(group_id, user_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "user_group",
        action: "add_user",
        data: {
          group_id: group_id,
          user_id: user_id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function add_chat_users_to_group(user_id) {
  return new Promise(async function (resolve, reject) {
    try {
      user_id.map(async (id) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
          // timeout:15000
        };
        const body = {
          resource: "chat",
          action: "add_user_chat_group",
          data: {
            user_id: Number(id),
          },
        };

        let response = await call_api(body, config);
        return resolve(response);
      });
    } catch (err) {
      return reject(err);
    }
  });
}

function create_context({
  name,
  password_policy,
  login_period_start,
  login_period_end,
  security_context_code,
  max_timeout,
  token_ttl,
  allowed_channels,
  browser_version,
  allowed_devices,
  device_version,
  two_factor_auth,
  holiday_login,
  description,
}) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "security_context",
        action: "create",
        data: {
          name: name,
          description: description,
          password_change_policy: password_policy,
          idle_max_timeout: max_timeout,
          token_ttl: token_ttl,
          security_context_code: security_context_code,
          login_context: {
            high: login_period_start,
            low: login_period_end,
          },
          allowed_channels: allowed_channels,
          allowed_devices: allowed_devices,
          device_versions: [
            {
              device_type: "and",
              device_version: "1",
            },
          ],
          two_factor_authentication: two_factor_auth,
          holiday_login: holiday_login,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function get_context(security_context_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "security_context",
        action: "get",
        data: {
          security_context_id: security_context_id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function get_reviews() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "profile",
        action: "reviews",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

// CHAT
// function chat_login() {
//   return new Promise(async function (resolve, reject) {
//     try {
//       let config = {
//         headers: {
//           "Content-Type": "application/json",
//           token: sessionStorage.getItem("token"),
//         },
//         // timeout:15000
//       };
//       const body = {
//         resource: "chat",
//         action: "user_login",
//         data: {},
//       };
//       let response = await call_api(body, config);
//       sessionStorage.setItem("chat_id", response.chat_user_identification);
//       return resolve(response);
//     } catch (err) {
//       return reject(err);
//     }
//   });
// }

function get_conversations() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "chat",
        action: "my_conversations",
        data: {
          chat_user_id: parseInt(sessionStorage.getItem("chat_id")),
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function add_chat_conversation(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "chat",
        action: "get_chat_conversation_id",
        data: {
          from_chat_user_id: parseInt(sessionStorage.getItem("chat_id")),
          //  to_chat_user_id:parseInt(id),
          user_id: parseInt(id),
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_clients() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "policies",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function chat_message_conversations(conversation_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "chat",
        action: "chat_conversations",
        data: {
          conversation_id: conversation_id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

// MARKETING--------------
// Relationship Managers
function get_relationship_managers() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "rm",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function assign_relationship_manager(selectedManager) {
  return new Promise(async function (resolve, reject) {
    try {
      selectedManager.map(async (manager) => {
        let config = {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("token"),
          },
          // timeout:15000
        };
        const body = {
          resource: "rm",
          action: "create",
          data: {
            employee_id: String(manager.value),
            user_id: parseInt(manager.key),
          },
        };
        console.log("THE BODY OF RM", body);
        let response = await call_api(body, config);
        return resolve(response);
      });
    } catch (err) {
      return reject(err);
    }
  });
}

// Sales Rep
function get_sales_rep() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "sales_rep",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function add_sales_rep({ name, email, phone }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "sales_rep",
        action: "create",
        data: {
          sales_rep_names: name,
          sales_rep_email: email,
          contact: phone,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function get_rep_details(rep_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };

      const body = {
        resource: "sales_rep",
        action: "sales_rep_details",
        data: {
          sales_rep_ref: rep_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

// Leads
function list_leads() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_open_leads() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "list_status_open_leads",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_pending_claims() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "claim",
        action: "list_pending_approval",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function approve_pending_claims(remarks) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "claim",
        action: "claim_approval",
        data: {
          system_claim_ref: localStorage.getItem("system_ref"),
          intermediary_approval_details: {
            approval_type: "approve",
            approval_remarks: remarks,
            intermediary_request_id: "3u90524534guhijkhhg"


            // "approval_document_path":"/test/test.pdf"
          },
        },
      };
      console.log("the body of approval", body);
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
// FEES AND TAXES

function list_fees() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "fees",
        action: "list_fees",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function add_fees({
  fee_name,
  fee_type,
  management,
  fee_reference,
  fee_description,
  taxed,
  entity_fee_account,
  entity_tax_ref,
  fee_value,
  remarks,
  slab,
}) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "fees",
        action: "add_fee",
        data: {
          fee_name: fee_name,
          fee_description: fee_description,
          fee_type: fee_type,
          fee_management: management,
          fee_value: fee_value,
          fee_slab: slab,
          entity_fee_ref: fee_reference,
          entity_fee_currency: "KES",
          tax_details: {
            is_taxed: taxed,
            taxes: entity_tax_ref.map((tax) => ({
              system_tax_ref: tax,
              is_inclusive: true,
            })),
          },
          entity_fee_account: entity_fee_account,
          remarks: remarks,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function getFeeDetails(entity_fee_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "fees",
        action: "get",
        data: {
          entity_fee_ref: entity_fee_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function calculateFee(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "fees",
        action: "calculate",
        data: {
          system_fee_ref: values.system_fee_ref,
          amount: values.amount,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_taxes() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "taxes",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_tax_category() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "tax_category",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function add_taxes({
  tax_name,
  tax_type,
  entity_tax_account,
  management,
  entity_tax_ref,
  tax_value,
  tax_description,
  tax_category,
  slab,
  remarks,
  systemTaxRef,
}) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "taxes",
        action: "add",
        data: {
          entity_tax_ref: entity_tax_ref,
          tax_name: tax_name,
          tax_description: tax_description,
          tax_type: tax_type,
          system_tax_category_ref: systemTaxRef,
          entity_tax_currency: "KES",
          entity_tax_account: entity_tax_account,
          tax_management: management,
          tax_value: tax_value,
          tax_category: tax_category,
          tax_slab: slab,
          remarks: remarks,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function calculateTax({ system_tax_ref, amount, inclusive }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "taxes",
        action: "calculate",
        data: {
          system_tax_ref: system_tax_ref,
          amount: amount.value,
          option: inclusive.value,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function getTaxDetails(entity_tax_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "taxes",
        action: "get",
        data: {
          entity_tax_ref: entity_tax_ref,
        },
      };
      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function rm_details(system_rm_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "rm",
        action: "rm_details",
        data: {
          system_rm_ref: `rm/${system_rm_ref}`,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function lead_details(lead_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "get",
        data: {
          lead_ref: `ld/${lead_ref}`,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function assign_rm_lead({ lead_ref, system_rm_ref }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "assign_rm",
        data: {
          lead_ref: `ld/${lead_ref}`,
          system_rm_ref: system_rm_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function assign_lead_sales_rep({ lead_ref, sales_rep_ref }) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "assign_lead_sales_rep",
        data: {
          lead_ref: `ld/${lead_ref}`,
          sales_rep_ref: sales_rep_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function close_lead(data) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "close",
        data: {
          lead_ref: `ld/${data.lead_ref}`,
          business_ref: data.business_ref,
          closure_remarks: data.remarks,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function incentify_lead(data) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "lead_incentive",
        data: {
          lead_ref: `ld/${data.lead_ref}`,
          incentive: {
            incentive_amount: data.incentive_amount,
            incentive_currency: data.incentive_currency,
            incentive_remarks: data.incentive_remarks,
          },
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function create_lead_quotation(data) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "create_quotation",
        data: {
          lead_ref: `ld/${data.lead_ref}`,
          lead_quotation_ref: data.lead_quotation_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function assign_open_lead(lead_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "lead",
        action: "assign_open_lead_entity",
        data: {
          lead_ref: lead_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_domains() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "entity_domain",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function add_domains(domain) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "entity_domain",
        action: "add",
        data: {
          domain: domain.name,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

// settlement
function listSettlement() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "acc_settlement",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function listConfigs() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "acc_settlement",
        action: "list_config",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function createConfig({
  intermediary_settlement_ref,
  name,
  description,
  account,
  type,
  frequency,
  frequency_day_of_week,
  frequency_day_of_month,
  frequency_remarks,
  your_ref,
  frequency_time,
  release_level,
  channel,
}) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "acc_settlement",
        action: "create_config",
        data: {
          stc_system_ref: channel,
          st_config_name: name,
          st_config_description: description,
          st_config_entity_ref: intermediary_settlement_ref,
          entity_account_number: account,
          st_config_type: type,
          st_config_release_level: release_level,
          st_config_frequency: {
            frequency_type: frequency,
            time_of_day: frequency_time,
            day_of_week: frequency_day_of_week,
            day_of_month: frequency_day_of_month,
          },
          st_remarks: frequency_remarks,
          st_reference: {
            reference_type: type,
            entity_ref: your_ref,
          },
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function listChannels() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "acc_settlement",
        action: "list_channel",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function createChannel() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "acc_settlement",
        action: "create_channel",
        data: {
          settlement_channel_currency: "KES",
          settlement_channel_name: "settlement test",
          settlement_channel_description: "describe...",
          tran_channel_code: "test",
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

// Schemes**************************************************
function listSchemes() {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "list",
        data: {},
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function checkPin(scheme_pin) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "check_scheme_pin_exists",
        data: {
          scheme_pin: scheme_pin,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function createScheme({
  scheme_name,
  scheme_ref,
  scheme_description,
  //   coordinates,
  scheme_details,
  scheme_pin,
  contact_person,
  scheme_admin_email,
  scheme_logo,
  underwriter_id,
}) {
  return new Promise(async function (resolve, reject) {
    try {
      let scheme_det = {};
      Array.isArray(scheme_details) &&
        scheme_details.map(({ key, value }) => {
          scheme_det = Object.assign(scheme_det, { [key]: value });
        });

      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "create",
        data: {
          scheme_name: scheme_name,
          scheme_code: scheme_ref,
          scheme_description: scheme_description,
          coordinates: [38.455, 4.556],
          scheme_details: scheme_det,
          scheme_pin: scheme_pin,
          contact_person: [
            {
              name: "name name",
              email: "emal@email.com",
              contacts: "0700000000",
            },
          ],
          scheme_admin_email: scheme_admin_email,
          scheme_logo: scheme_logo,
          underwriter_id: underwriter_id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function schemeDetails(scheme_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "get",
        data: {
          scheme_id: scheme_id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function addSchemeDocument(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "add_scheme_doc",
        data: {
          system_scheme_ref: values.scheme_ref,
          scheme_document: {
            doc_name: values.doc_name,
            doc_description: values.doc_description,
            doc_path: values.document,
          },
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function listSchemeDocuments(scheme_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "list_scheme_doc",
        data: {
          system_scheme_ref: scheme_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function addSchemeGroup(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let scheme_group_det = {};
      Array.isArray(values.scheme_group_detail) &&
        values.scheme_group_detail.map(({ key, value }) => {
          scheme_group_det = Object.assign(scheme_group_det, { [key]: value });
        });
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "create_group",
        data: {
          scheme_group_name: values.scheme_group_name,
          scheme_group_description: values.scheme_group_description,
          scheme_group_detail: values.scheme_group_det,
          scheme_group_type: values.scheme_group_type,
          scheme_id: Number(values.scheme_id),
          policy_management_type: values.policy_management_type,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function listSchemeGroup(scheme_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "get_scheme_group",
        data: {
          system_scheme_ref: scheme_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function schemeGroupDetails(system_scheme_group_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "get_group",
        data: {
          system_scheme_group_ref: `sch-grp/${system_scheme_group_ref}`,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function addSchemeGroupMember(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "add_scheme_member",
        data: {
          scheme_id: Number(values.scheme_id),
          system_scheme_group_ref: values.system_scheme_group_ref,
          member_names: values.member_names,
          member_details: values.member_details,
          member_email: values.member_email,
          member_contact: values.member_contact,
          member_number: values.member_number,
          member_identification: {
            id_type: values.id_type,
            id_number: values.id_number,
          },
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function removeSchemeGroupMember(scheme_member_id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "remove_scheme_member",
        data: {
          scheme_member_id: scheme_member_id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function listGroupMembers(system_scheme_group_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "list_group_members",
        data: {
          system_scheme_group_ref: system_scheme_group_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function getMemberDetails(system_scheme_group_ref, system_scheme_member_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "get_group_scheme_member",
        data: {
          system_scheme_group_ref: system_scheme_group_ref,
          system_scheme_member_ref: system_scheme_member_ref,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function negotiateRate(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "create_scheme_rate",
        data: {
          system_scheme_group_ref: `sch-grp/${values.system_scheme_group_ref}`,
          system_token_ref: values.system_token_ref,
          scheme_rate_name: values.scheme_rate_name,
          scheme_rate_description: values.scheme_rate_description,
          scheme_rate_ref: values.scheme_rate_ref,
          product_id: Number(values.product_id),
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function fetch_rates(system_scheme_group_ref) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout:15000
      };
      const body = {
        resource: "schemes",
        action: "get_group_scheme_products",
        data: {
          system_scheme_group_ref: `sch-grp/${system_scheme_group_ref}`,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function create_client_quotation(values) {
  console.log("creating cquti", values)
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout: 15000
      };
      const body = {
        resource: "quotations",
        action: "create_guest_client_quotation",
        data: {
          client_names: values.client_names,
          client_email: values.client_email,
          client_contact: values.client_contact,
          insurance_class: values.insurance_class,
          cover_type_code: values.cover_type_code,
          guest_client_quotation_ref: values.guest_client_quotation_ref,
          quotation_remarks: values.quotation_remarks

        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_client_quotation(values) {
  return new Promise(async function (resolve, reject) {
    console.log("fetching quation client list")
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout: 15000
      };
      const body = {
        resource: "quotations",
        action: "list_guest_client_quotation_drafts",
        data: {}
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_guest_client_recommendations(id) {
  return new Promise(async function (resolve, reject) {
    console.log("fetching guest client recommendations");
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
      };
      const body = {
        resource: "quotations",
        action: "list_guest_client_recommendations",
        data: {
          guest_client_quotation_id: id,
        },
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_client_quotation_risks(id) {
  return new Promise(async function (resolve, reject) {
    console.log("fetching quation risks client list")
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout: 15000
      };
      const body = {
        resource: "quotations",
        action: "fetch_guest_client_quotation_risks",
        data: {
          guest_client_quotation_id: id
        }
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


function view_client_quotation(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout: 15000
      };
      const body = {
        resource: "quotations",
        action: "guest_client_quotation_draft",
        data: {
          guest_client_quotation_id: id
        }
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function sendQuotationToGuestClient(id) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout: 15000
      };
      const body = {
        resource: "quotations",
        action: "send_quotation_to_guest_client",
        data: {
          guest_client_quotation_id: id
        }
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


function create_guest_quotation_recommendation(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
      };
      const body = {
        resource: "quotations",
        action: "create_guest_quotation_recommendation",
        data: {
          product_id: values.product_id,
          guest_client_quotation_id: values.guest_client_quotation_id,
          recommendation_level: values.recommendation_level,
          recommendation_remarks: values.recommendation_remarks,
          risks: values.risks,
        },
      };

      let response = await call_api(body, config);
      console.log("RECOMMENDATION+++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

// base functions

function call_api(body, config) {
  return new Promise(function (resolve, reject) {
    axios
      .post(api_url, body, config)
      .then(function (response) {
        return resolve(response.data.result);
      })
      .catch(function (error) {
        return reject(handle_api_error(error));
      });
  });
}


// function call_api_v2(body, config) {
//   return new Promise(function (resolve, reject) {
//     axios
//       .post(api_url_v2, body, config)
//       .then(function (response) {
//         console.log("V2-RES==", response)
//         return resolve(response.data.result);
//       })
//       .catch(function (error) {
//         console.log("Error result", error)
//         return reject(handle_api_error(error));
//       });
//   });
// }

async function call_api_v2(body, config) {
  try {
    const response = await axios.post(api_url_v2, body, config);
    return response.data.result
     
  } catch (error) {
    console.log("Error result", error.response.data.errors);
    throw handle_api_error(error.response.data.errors);
  }
}

async function upload_api(upload_type, file) {
  return new Promise(async function (resolve, reject) {
    const fmData = new FormData();
    const uploadconfig = {
      headers: {
        "Content-Type": "multipart/form-data",
        token: sessionStorage.getItem("token"),
      },
    };
    fmData.append(upload_type, file);
    axios
      .post(file_upload_url, fmData, uploadconfig)
      .then(function (response) {
        console.log("RESPONSEFILEUPLOAD===", response)
        return resolve(response);
      })
      .catch(function (error) {
        return reject(handle_api_error(error));
      });
  });
}




async function create_product_underwriter(values) {
  console.log("create product_underwriter", values)
  return new Promise(async function (resolve, reject) {
    try {

      const body = {
            "service":{
                "name":"underwriting",
                "version":"v1"
            },
            "resource":{
                "name":"intermediary",
                "version":"v1"
            },
            "action":{
                "name":"addUnderwriterToIntermediary",
                "version":"v1"
            },  
        "data":{
          "underwriters": [
            {
            "underwriterSystemRef": values.underwriter,
            "settlementType": values.settlementType,
            "settlementFrequency": values.settlementFrequency,
            "bankPaymentDetails": {
              "bankName": values.bankName,
              "accountNumber": values.accountNumber || 134898888,
              "branch": values.branch,
            },
              "mpesaPaymentDetails": {
                "paybBillNumber": values.paybillNumber
              },
            "notificationEmails": ["test55@example.com"]
            }
          ]
        }

        }


      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("U PROD +++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function create_credentials(values) {
  return new Promise(async function (resolve, reject) {
    try {
  
      const body = {
        "service":{
            "name":"underwriting",
            "version":"v1"
        },
        "resource":{
            "name":"underwriterDmvic",
            "version":"v1"
        },
        "action":{
            "name":"addCredentials",
            "version":"v1"
        },  
        "data":{
            "username": values.email,
            "password": values.password
        }
    }
          

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function create_dmvic(values) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
      "service": {
          "name": "underwriting",
          "version": "v1"
      },
      "resource": {
          "name": "underwriterDmvic",
          "version": "v1"
      },
      "action": {
          "name": "appendUnderwriterToEntity",
          "version": "v1"
      },
      "data": {
          "underwriter": {
              "underwriterSystemRef": values.underwriter,
              "memberId": values.id
          }
      }
  }

      let response = await call_api_v2(body, CONST.CONFIG);
   
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
 

async function attach_product_benefit(values, id) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("product benefit creation server==", values)
      console.log("Adjustable Daily ===", values.dailyIsAdjustable?.includes("yes"))
      console.log("Adjustable Limit ===", values.limitIsAdjustable?.includes("yes"))
 
      const body = {
        "service": {"name": "underwriting", "version": "v1"},
        "resource": {"name": "product", "version": "v1"},
        "action": {"name": "addBenefitToProduct", "version": "v1"},
        "data": {
          "productSystemRef": id,
          "productBenefit": {
            "benefitSystemRef": values.category,
            "benefitCalculationtype": values.calculationType,
            "benefitCalculationValue": parseFloat(values.value) || 0,
            "benefitLimit": {
              "minimum": parseInt(values.limitMin) || 0,
              "maximum": parseInt(values.limitMax) || 0,
              "isAdjustable": values.limitIsAdjustable?.includes("yes") || false,
              "defaultLimit": parseInt(values.limitDefault) || 0
            },
            "benefitDays": {
              "minimum": parseInt(values.dailyMin) || 0,
              "maximum": parseInt(values.dailyMax) || 0,
              "isAdjustable": values.dailyIsAdjustable?.includes("yes") || false,
              "defaultDays": parseInt(values.dailyDefault) || 0,
              "benefitDays": parseInt(values.dailyDays) || 0
            },
            "benefitType": values.benefitType,
            "benefitInternaleRef": values.reference, 
            "benefitClaim": {
              "canmakeClaim": values.claimCanClaim === "yes" || false,
              "consumedOnClaim": values.claimConsumed === "yes" || true,
              "claimReinstatement": values.claimReinstatement || "manual"
            }
          }
        }
      };

      let response = await call_api_v2(body, CONST.CONFIG);
      
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function create_product_benefit(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("cproduct benefit creation server==", values)

      const body = {
      "service":{"name":"underwriting","version":"v1"},
      "resource":{"name":"benefits","version":"v1"},
      "action":{"name":"createBenefit","version":"v1"},
      "data":{
              "benefitCategory": values.benefitCategory,
              "benefitName": values.benefitName,
              "benefitReference": values.benefitReference,
              "benefitDescription": values.benefitDescription,
              "benefitType": "",
              "benefitEmbededProductRef": values.benefitEmbededProductRef,
              "benefitServiceType": "",
              "benefitServiceRef":"",
              "benefitCoverType": values.benefitCoverType,
              "isPremiumBenefit": values.isPremiumBenefit,
              "benefitrateBaseOn": values.benefitrateBaseOn,
              "benefitRateSystemref":"",
              "isConsumedonClaim": values.isConsumedonClaim,
              "claimReinstatement": values.claimReinstatement
                  }
      }  

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("RECOMMENDATION+++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}



async function fetch_product_benefits(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("dmivic creation server==", values)

      const body = {
        "service":{"name":"underwriting","version":"v1"},
          "resource":{"name":"benefits","version":"v1"},
          "action":{"name":"fetchEntityBenefits","version":"v1"},
          "data":{}}

                let response = await call_api_v2(body, CONST.CONFIG);
                console.log("product benefits+++", response)
                return resolve(response);
              } catch (err) {
                return reject(err);
              }
            });
          }

//create rate 
async function create_rate(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("rate creation server==", values)

      const body = {
          "service": {
            "name": "underwriting",
            "version": "v1"
          },
          "resource": {
            "name": "rate",
            "version": "v1"
          },
          "action": {
            "name": "createRate",
            "version": "v1"
          },
          "data": {
            "rateCode": values.rateCode,
            "version": "v1",
            "rateName": values.rateName,
            "rateDescription": values.rateDescription,
            "rateType": values.rateType,
            "rateTable": values.rateTable,
            "rateSlab": values.rateSlab,
            "rateValue": values.rateValue
          }
        }

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("CHARGES++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function list_rates(values) {
  return new Promise(async function (resolve, reject) {
    try {

      const body = {
        "service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"rate","version":"v1"},
        "action":{"name":"fetchUnderwriterRates","version":"v1"},
        "data":{}
      };

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("ratesRESPONSE===", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function list_intermediary_underwriters(values) {
  return new Promise(async function (resolve, reject) {
    try {

      const body = {
          "service":{
              "name":"underwriting",
              "version":"v1"
          },
          "resource":{
              "name":"intermediary",
              "version":"v1"
          },
          "action":{
              "name":"listIntermediaryUnderwriters",
              "version":"v1"
          },  
        "data": {}
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("LS UNDER RESPONSE===", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function list_commissions(values) {
  return new Promise(async function (resolve, reject) {
    try {

      const body = {
        "service" : {
          "name": "underwriting",
          "version": "v1"
        },
        "resource" : {
           "name": "commision",
           "version": "v1"
        },
        "action": {
          "name" : "fetchCommisions",
          "version": "v1"
        },
        "data" : {}
      }

      let response = await call_api_v2(body, CONST.CONFIG);

      console.log("response commisions===", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function list_dmvics(values) {
  return new Promise(async function (resolve, reject) {
    try {

   const body = {
        "service":{
            "name":"underwriting",
            "version":"v1"
        },
        "resource":{
            "name":"underwriterDmvic",
            "version":"v1"
        },
        "action":{
            "name":"listDmvicUnderwriters",
            "version":"v1"
        },  
        "data":{}
    }

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("LS DMVICS RESPONSE===", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function create_product(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("product creation server==", values)

      const body = {
        "service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"product","version":"v1"},
        "action":{"name":"createProduct","version":"v1"},
          "data":
          {
              "basePremiumRate": values.rate,
              "insuranceCategory": values.category,
              "insuranceClass": values.insuranceclass,
              "productInternalRef": values.ref,
              "productCommision": +values.commission,
              "covertypeSystemRef": values.coverType,
              "productName": values.name,
              "productLogo": values.productImage,
              "rateSystemRef":  values.rate,
              "productDescription": values.description,
              "underwriterSystemRef": values.underwriter,
              "bussinessType": "INTERMEDIARY",
              "productCountryCode":  "KE",
              "productCharges": values.charges,
              "supportedCurrency": values.currency || "KSH",
              "productSalesChannel": values.salesChannel,
              "productPremium":{
                    "maximum": +values.premiumMax,
                    "minimum": +values.premiumMin
                },
              "productCover":{
                    "maximum": +values.coverPeriodMin,
                    "minimum": +values.coverPeriodMax,
                    "maximumNumTostartDate": 0,
                    "supportedPeriods": values.period.map(num => parseFloat(num))
              },
              "basePremiumRate":{
              "rateType": values.rate.rateType,
              "value": values.rate.value
          }
          }
        } 

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("NEWPRODUCT====", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function update_product(values, productSystemRef) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log(" update product creation server==", productSystemRef)
const body = {
  service: { name: "underwriting", version: "v1" },
  resource: { name: "product", version: "v1" },
  action: { name: "updateProduct", version: "v1" },
  data: {
    productSystemRef,
    update: {
      productName: values.name || "",
      productDescription: values.description || "",
      productLogo: values.productImage || null,
      productInternalRef: values.ref || null,
      insuranceClass: values.insuranceclass || "",
      insuranceCategory: values.category || "",
      productCommission: Number(values.commission) || 0,
      covertypeSystemRef: values.coverType || null,
      underwriterSystemRef: values.underwriter || null,
      bussinessType: "INTERMEDIARY",
      productCountryCode: values.countryCode || "KE",
      supportedCurrency: values.currency ? (Array.isArray(values.currency) ? values.currency : [values.currency]) : ["KSH"],
      productCharges: values.charges || [],
      productSalesChannel: values.salesChannel || [],
      productPremium: {
        minimum: Number(values.premiumMin) || 0,
        maximum: Number(values.premiumMax) || 0
      },
      supportedPeriods: (values.period || []).map(Number).filter(n => !isNaN(n)),
      productCover: {
        minimum: Number(values.coverPeriodMin) || 0,
        maximum: Number(values.coverPeriodMax) || 0,
        maximumNumTostartDate: 0,
        
      },
      basePremiumRate: {
        rateType: values.rate?.rateType || "FIXED",
        value: Number(values.rate?.value) || 0
      }
    }
  }
};
      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("NEWPRODUCT====", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function list_benefit_types(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout: 15000
      };
      const body = {
        resource: "covertype",
        action: "list",
        data: {
        }
      };

      let response = await call_api(body, config);
      return resolve([]);
    } catch (err) {
      return reject(err);
    }
  });
}


async function list_charges() {
  return new Promise(async function (resolve, reject) {
    try {


      const body = {
          "service": {
              "name": "underwriting",
              "version": "v1"
          },
          "resource": {
              "name": "product",
              "version": "v1"
          },
          "action": {
              "name": "fetchProductCharges",
              "version": "v1"
          },
          "data": {
          }
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("RESPONSE RESET PASSWORD REQUEST===", response)
      // sessionStorage.setItem("token", response.accessToken);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}




async function list_categories(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout: 15000
      };

   const body =  
   {
  "resource": "benefit_category",
  "action": "list",
  "data": {},
  "metadata": {}
}

      let response = await call_api(body, config);
      console.log("category list123===", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetch_benefit_categories(){
  return new Promise(async function (resolve, reject) {
    try {

  const body = {
      "service": {
        "name": "underwriting",
        "version": "v1"
      },
      "resource": {
        "name": "benefit",
        "version": "v1"
      },
      "action": {
        "name": "fetchBenefitCategories",
        "version": "v1"
      },
      "data": {
        
      }
    }

      let response = await call_api_v2(body, CONST.CONFIG);
  
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_cover_types(values) {
  return new Promise(async function (resolve, reject) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/json",
          token: sessionStorage.getItem("token"),
        },
        // timeout: 15000
      };
      const body = {
        resource: "covertype",
        action: "list",
        data: {
        }
      };

      let response = await call_api(body, config);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function create_productbenefit_benefit(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("rate creation server==", values)

      const body = {
        "service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"product","version":"v1"},
        "action":{"name":"createProductBenefit","version":"v1"},
        "data":{  
                name :"Motor Benefits",
                description:"Benefits for motor"
                }
        }  
        //  

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("CHARGES++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function add_product_benefit(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("rate creation server==", values)

      const body = {
        "service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"product","version":"v1"},
        "action":{"name":"addBenefitProductBenefit","version":"v1"},
        "data":{
                    
              "productBenefitSystemRef": "00d2c136-1d28-4612-89cb-28a8924f0ca0",
              "benefit":{
                  "benefitSystemRef":"32b32ed5-2783-4ce1-beac-3747eaab4686",
                  "freeLimit":55000,
                  "maximumFreeLimit":110000,
                  "type":"OPTIONAL",
                  "premiumType":"PREMIUM",
                  "consumedOnClaim":"YES",
                  "claimReinstatement":"YES",
                  "rateSystemRef":"30beeab3-0fb0-44ad-97e7-ca130bcb341e",
                  "rateCalculationBasedOn":"PREMIUM"
              }
            }
        }  

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("CHARGES++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function configure_policy_no(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("rate creation server==", values)

      const body = {
        "service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"product","version":"v1"},
        "action":{"name":"updateProductPolicyNumConfig","version":"v1"},
        "data":{
            "productSystemRef": values.productSystemRef,
          "policyNumConfigcategory": values.policyNumConfigcategory,
          "policyNumConfigFixed": values.policyNumConfigFixed, 
          "policyNumrangeMinimumNotification": values.policyNumrangeMinimumNotification || 0,
          "policyNumConfigRangeTable": values.policyNumConfigRangeTable

        }}

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("Policy No++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function create_product_excess(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("excess creation server==", values)

      const body = {
        "service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"product","version":"v1"},
        "action":{"name":"updateProductExcess","version":"v1"},
        "data":{
            "productSystemRef": values.productSystemRef,
            "productExcess": values.productExcess
            
        }}

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("Policy No++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function test_product_excess(values) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"underwriting","version":"v1"},
      "resource":{"name":"product","version":"v1"},
      "action":{"name":"excessCalculator","version":"v1"},
      "data":{
          "productSystemRef": values.productSystemRef,
          "basePremium": values.basePremium,
          "excessValue": values.excessValue 
        }
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function update_policy_config(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("policy config creation server==", values)

      const body = {
        "service":{"name":"underwriting","version":"v1"},
          "resource":{"name":"product","version":"v1"},
          "action":{"name":"updateProductPolicyConfig","version":"v1"},
          "data":{
              "productSystemRef": values.productSystemRef,
              "autoRenewalNotification": +values.autoRenewalNotification,
              "covernoteIssuance": values.covernoteIssuance ,
              "covernoteIssuanceTemplate": values.valuationTemplate,
              "isValuationRequired": values.valuationRequired,
              "valuationTemplateRef": values.valuationTemplate,
              "valuers": values.valuers
          }}
	

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("Policy No++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function create_product_liability(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("liability creation server==", values);

      const body = {
        "service":{"name":"underwriting","version":"v1"},
          "resource":{"name":"product","version":"v1"},
          "action":{"name":"addProductLiability","version":"v1"},
          "data": values
        }

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("Policy No++", response);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function issue_motor_cert(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("rate creation server==", values)

      const body = {
        "service":{"name":"underwriting","version":"v1"},
          "resource":{"name":"product","version":"v1"},
          "action":{"name":"updateProductMotorCertificate","version":"v1"},
          "data":{
              "productSystemRef": values.productSystemRef,
              "motorCertifcateConfigType": values.issuanceType,
              "motorCertifcateConfigIssuer": values.thirdPartyIssuer,
              "motorCertifcateConfigDoublevalidation": values.validateDoubleInsurance,
              "dmvicCategory": values.dmvicCategory,
              "dmvicSubcategory": values.dmvicVehicleType,
              "onCertificateFailure": values.onDmvicFailure,
              "certificateIssuing": values.dmvicCertificate,
              "intergrationConfigRef": values.intergrationConfigRef,
              "certificateIssuing": values.certificateIssuing
          }}


      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("Policy No++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}  

async function create_payment(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("payment creation server==", values)

      const body = {"service":{"name":"underwriting","version":"v1"},
      "resource":{"name":"product","version":"v1"},
      "action":{"name":"updateProductPaymentConfig","version":"v1"},
      "data":{
          "productSystemRef": values.productSystemRef,
          "isPartPaymentAllowed": values.part_payment_allowed,
          "numberOfPartPayments": values?.parts?.length,
          "minimumPartPaymentAmount": values.min_amount,
          "maximumPartPaymentAmount": values.max_amount,
          "minimumPartPaymentPeriod": values.min_period,
          "maximumPartPaymentPeriod": values.max_period,
          "partPayments": values.parts
      }}



      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("Policy No++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
} 

async function remove_product_benefit(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("rate creation server==", values)
      const body = {
        "service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"product","version":"v1"},
        "action":{"name":"removeBenefitProductBenefit","version":"v1"},
        "data":{
                    
              "productBenefitSystemRef": "00d2c136-1d28-4612-89cb-28a8924f0ca0",
              "benefitSystemRef":"3e929a4c-e74b-41b0-b273-2a1f086ed82e"
            }
        }  

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("CHARGES++", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function fetch_my_underwriters_v2() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service":{
              "name":"underwriting",
              "version":"v1"
          },
          "resource":{
              "name":"underwriter",
              "version":"v1"
          },
          "action":{
              "name":"listUnderwriters",
              "version":"v1"
          },  
          "data":{}
      }
      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


function list_my_products() {
  return new Promise(async function (resolve, reject) {
    try {

  const body ={
    "service":{"name":"underwriting","version":"v1"},
    "resource":{"name":"product","version":"v1"},
    "action":{"name":"fetchEntityProducts","version":"v1"},
    "data":{}
    }

      let response = await call_api_v2(body, CONST.CONFIG);
  
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}
function list_undewriter_products(insuranceClass) {
  return new Promise(async function (resolve, reject) {
    try {

  const body ={
    "service":{"name":"intermediary","version":"v1"},
    "resource":{"name":"products","version":"v1"},
    "action":{"name":"forSale","version":"v1"},
      "data": {
          "insuranceClass":insuranceClass
      } 
      
    }  

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("res", response)
  
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


function fetch_product_details(productSystemRef) {
  return new Promise(async function (resolve, reject) {
    try {
    const body = {
      "service":{"name":"underwriting","version":"v1"},
      "resource":{"name":"product","version":"v1"},
      "action":{"name":"fetchProductDetails","version":"v1"},
      "data":{
          "productSystemRef": productSystemRef
      }}

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("product details==", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function publish_product(productSystemRef, status) {
  return new Promise(async function (resolve, reject) {
    try {

  const body = {
      "service": {
        "name": "underwriting",
        "version": "v1"
      },
      "resource": {
        "name": "product",
        "version": "v1"
      },
      "action": {
        "name": "updateProductStatus",
        "version": "v1"
      },
      "data": {
        "productSystemRef": productSystemRef,
        "status": status
      }
    }

      let response = await call_api_v2(body, CONST.CONFIG);
  
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_subclass(values) {
  return new Promise(async function (resolve, reject) {
    try {


    const body = {
      "service":{"name":"intermediary","version":"v1"},
      "resource":{"name":"classes","version":"v1"},
      "action":{"name":"fetch","version":"v1"},
        "data": { }
      }
  

    let response = await call_api_v2(body, CONST.CONFIG);
      console.log("product details==", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}



async function setup_product_accounting_config(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("product accounting creation server==", values)

      let body = {
      "service":{
      "name":"underwriting",
      "version":"v1"
      },
      "resource":{"name":"product","version":"v1"},
      "action":{"name":"createProductAccountingConfig","version":"v1"},
      "data": {
            "productSystemRef": values.productSystemRef,
            "taxType": values.handleTaxes === "yes" ? "auto" : "manual",
            "autoGenerateEtimsCert": values.generateEtims === "yes" ? true : false,
            "autoRemmitTax": values.remitTax === "yes" ? true : false,
            "etimsConfig": {
              "etimsToken": values.etimsToken
            },
            "settlementChannel": values.settlementChannel,
            "settlementMpesaNumber": values.mpesaNumber ,
            "settlementMpesaPaybill": values.mpesaPaybill,
            "settlementBankDetails": {
              "bankName": values.bankName,
              "accountNumber": values.accountNumber
            },
            "salesRepCommisionSettlementType": values.paymentMethod,
            "settlementType": values.settlementType,
            "settlementTypeThresholdValue": values.threshold || 0,
            "salesRepCommisionRep": values.salesRepCommisionRep,
            "productAccountingConfigName": values.productAccountingConfigName,
          }
        }
      
       let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function update_product_accounting_config(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("product accounting update server==", values)

      let body = {
      "service":{
      "name":"underwriting",
      "version":"v1"
      },
      "resource":{"name":"product","version":"v1"},
      "action":{"name":"updateProductAccountingConfig","version":"v1"},
      "data": {
            "productAccountingSystemRef": values.productAccountingSystemRef,
            "taxType": values.handleTaxes === "yes" ? "auto" : "manual",
            "autoGenerateEtimsCert": values.generateEtims === "yes" ? true : false,
            "autoRemmitTax": values.remitTax === "yes" ? true : false,
            "etimsConfig": {
              "etimsToken": values.etimsToken,
              "etimsTaxNumber": values.etimsTaxNumber
            },
            "settlementChannel": values.settlementChannel,
            "settlementMpesaNumber": values.mpesaNumber ,
            "settlementMpesaPaybill": values.mpesaPaybill,
            "settlementBankDetails": {
              "bankName": values.bankName,
              "accountNumber": values.accountNumber
            },
            "salesRepCommisionSettlementType": values.paymentMethod,
            "settlementType": values.settlementType,
            "settlementTypeThresholdValue": values.threshold || 0,
            "salesRepCommisionRep": values.salesRepCommisionRep,
            "productAccountingConfigName": values.productAccountingConfigName,
          }
        }
      
       let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve({});
    } catch (err) {
      return reject(err);
    }
  });
}



async function setup_product_requirements(values) {
 return new Promise(async function (resolve, reject) {
    try {
      console.log("setup kyc requirements===", values)   
      const body = {
          "service":{"name":"underwriting","version":"v1"},
          "resource":{"name":"product","version":"v1"},
          "action":{"name":"addUpdateProductRequirement","version":"v1"},
          "data":{
              "productSystemRef": values.productSystemRef,
              "productRequirements": values.productRequirements
          }}
                
                let response = await call_api_v2(body, CONST.CONFIG);
                return resolve(response);
              } catch (err) {
                return reject(err);
              }
      });
}

async function setup_product_pricing(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("pricing creation server==", values)

      const body = {
        "service":{
        "name":"underwriting",
        "version":"v1"
        },
        "resource":{"name":"product","version":"v1"},
        "action":{"name":"updateProductPricingConfig","version":"v1"},
          "data": {
          "productSystemRef": values.productSystemRef,
          "productPricing": {
            "productPricingConfigName": values.productPricingConfigName,
            "productPricingConfigDescription": values.productPricingConfigDescription,
            "periodPricing": values.periodPricing,
            "riskPricing": {},
            "channelPricing": values.channelPricing,
            "entityRef": values.entityRef
          }
        }
        }

      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function setup_product_tnc(values) {
  return new Promise(async function (resolve, reject) {
    try {
      console.log("Tnc creation server==", values)

     const body = {
      "service":{
      "name":"underwriting",
      "version":"v1"
      },
      "resource":{"name":"product","version":"v1"},
      "action":{"name":"updateProductTermsAndCondition","version":"v1"},
      "data": values
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("NEWPRODUCT====", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

function list_plans() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service": {"name": "underwriting", "version": "v1"},
        "resource": {"name": "plan-management", "version": "v1"},
        "action": {"name": "listPlans", "version": "v1"},
        "data": {}
      };
      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


function list_policies() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service": { "name": "underwriting", "version": "v1" },
        "resource": { "name": "policy", "version": "v1" },
        "action": { "name": "listPolicies", "version": "v1" },
        "data": {
        }
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("policies server res===", response)
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function upload_policy(values, policyRemarks) {
  console.log("server policy!@#$567890", values)
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service": { name: "intermediary", version: "v1" },
        "resource": { name: "policies", version: "v1" },
        "action": { name: "upload", version: "v1" },
        "data": {
          "policies": [{
            "insuranceClassRef": values.insuranceClass, 
            "coverType": values.CoverType,
            "policyCover": {
              "coverType": values.coverType,
              "endDate": values.endDate, 
              "startDate": values.startDate
            },
            "policyNumber": values.policyNumber,
            "policyPremium": {
              "basePremium": Number(values.basePremium),
              "additionalPremium": Number(values.additionalPremium),
              "totalCharges": Number(values.totalCharges),
              "totalDiscount": Number(values.totalDiscount)
            },
            "clientDetails": {
              "email": values.email,
              "phone": values.phone.toString(),
              "kraPin": values.kraPin,
              "firstName": values.firstName,
              "lastName": values.lastName,
              "middleName": values.middleName,
              "kyc": {}
            },
            "riskDetails": {
              "value": values.riskValue,
              "riskRef": values.riskRef,
              "chassisNumber": values.riskchassisNumber,
              "make": values.riskMake,
              "model": values.riskModel
            },
            "policyCurrency": values.policyCurrency.toLowerCase(), // Standardized to lowercase
            "policyExternalRef": values.policyExternalRef || "N/A", 
            "underwriterInternalRef": values.underwriterInternalRef || "N/A", 
            "commisionEarned": Number(values.commisionEarned), 
            "externalProductRef": values.externalProductRef || "N/A" // 
          }],
          "policyRemarks": policyRemarks,
          "channel": "WEB"
        }
      };

      
      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("NEWPRODUCT====", response);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchEntitySystemQuotations() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service": {"name": "underwriting", "version": "v1"},
        "resource": {"name": "quotation", "version": "v1"},
        "action": {"name": "fetchEntitySystemQuotations", "version": "v1"},
        "data": {}
      };
      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}

async function quotationDetails(systemQuotationRef) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service": {"name": "client", "version": "v1"},
        "resource": {"name": "quotation", "version": "v1"},
        "action": {"name": "quotationDetails", "version": "v1"},
        "data": {
          "systemQuotationRef": systemQuotationRef
        }
      };
      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function listEntityCommissions() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service": {
          "name": "underwriting",
          "version": "v1"
        },
        "resource": {
          "name": "commision",
          "version": "v1"
        },
        "action": {
          "name": "listEntityCommissions",
          "version": "v1"
        },
        "data": {}
      };
      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchCommissionDetails(systemEntityCommisionRef) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service": {
          "name": "underwriting",
          "version": "v1"
        },
        "resource": {
          "name": "commision",
          "version": "v1"
        },
        "action": {
          "name": "fetchCommissionDetails",
          "version": "v1"
        },
        "data": {
          "systemEntityCommisionRef": systemEntityCommisionRef
        }
      };
      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function create_client_direct_quoation(values) {
        console.log("client quoation creation server==", values)
  return new Promise(async function (resolve, reject) {
    try {
      const formattedBenefits = values?.selectedBenefits?.map(benefit => ({
        benefitSystemRef: benefit?.benefitSystemRef,
        params: {
          limit: benefit?.benefitLimit?.defaultLimit || 0,
        },
      }));

        const formattedExcesses = values?.excesses?.map(ex => ({
          name: ex.name,
          params: {}
        }));
      

      let body = {
         "service":{
        "name":"underwriting",
        "version":"v1"
        },
        "resource":{
            "name":"quotation",
            "version":"v1"
        },
        "action":{
            "name":"createEntityDirectQuotation",
            "version":"v1"
        }, 
        "data": {
                quotationInternalRef: values.internalRef,
                quotationRemarks: values.description,
                riskDetails: {
                    riskValue: values.value,
                    riskRef: values.regNo,
                    riskDetails: {
                        make: values.make,
                        model: values.model,
                        year: values.year
                    }
                },
                // productSystemRef: values.product,
                clientDetails: {
                    email: values.email,
                    names: {
                        firstName: values.firstName,
                        lastName: values.lastName
                    },
                    phone: values.phone,
                    clientType: values.kycType,
                    kyc: {...values.kycType},
                    kraPin: values.kraPin
                },
                 coverDetails :{
                 startDate : values.coverStartDate,
                 coverPeriod :+values.coverPeriod,
                 coverTypeSystemRef: values.coverType,
                },
                productDetails:{
                productSystemRef : values.product,
                productBenefits :[...formattedBenefits],
                productExcess : [...formattedExcesses]
             }
                // benefits : formattedBenefits
            }
        }
    
       let response = await call_api_v2(body, CONST.CONFIG);
      return resolve({});
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchClientQuotations() {
  return new Promise(async function (resolve, reject) {
    try {
          const body = {
            "service":{"name":"entity","version":"v1"},
            "resource":{"name":"intermediary","version":"v1"},
            "action":{"name":"systemQuotations","version":"v1"},
            "data":{}}
      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchClientQuotationDetails(systemQuotationRef) {
  return new Promise(async function (resolve, reject) {
    try {
          const body = {
            "service":{"name":"client","version":"v1"},
            "resource":{"name":"quotation","version":"v1"},
            "action":{"name":"quotationDetails","version":"v1"},
              "data":
              {
                      "systemQuotationRef": systemQuotationRef
              }
            } 
      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}

async function complete_client_direct_quoation(systemQuotationRef) {
  return new Promise(async function (resolve, reject) {
    try {
    const body = {
      "service":{"name":"underwriting","version":"v1"},
      "resource":{"name":"quotation","version":"v1"},
      "action":{"name":"completeQuotation","version":"v1"},
        "data":
        {
          "systemQuotationRef": systemQuotationRef
        }
      }  
          
       let response = await call_api_v2(body, CONST.CONFIG);
       console.log("Complete====", response)
      return resolve({});
    } catch (err) {
      return reject(err);
    }
  });
}


async function request_payment_direct_quoation(values) {
  return new Promise(async function (resolve, reject) {
    try {
    const body = {"service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"quotation","version":"v1"},
        "action":{"name":"requestPayment","version":"v1"},
          "data":
          {
            "systemQuotationRef": values.systemQuotationRef,
            "QuotationPaymentDetails":{
                "paymentProvider": values.paymentProvider || "mpesa",
                "params":{
                    "PhoneNumber": values.phoneNumber
                }
            }
          }
        }  
            
       let response = await call_api_v2(body, CONST.CONFIG);
       console.log("Complete====", response)
      return resolve({});
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchInvoices(page=1) {
  return new Promise(async function (resolve, reject) {
    try {
    const body = {
      "service":{"name":"intermediary","version":"v1"},
      "resource":{"name":"invoice","version":"v1"},
      "action":{"name":"fetchIntermediaryInvoices","version":"v1"},
        "data":
        {
              "querryOptions":{
                  "page": page
              }
        }
      } 
      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchInvoiceDetails(invoiceSystemRef) {
  return new Promise(async function (resolve, reject) {
    try {
    const body = {
      "service":{"name":"underwriting","version":"v1"},
    "resource":{"name":"accounting","version":"v1"},
    "action":{"name":"invoiceDetails","version":"v1"},
      "data":
      {
      "invoiceSystemRef": invoiceSystemRef
      }
    }   
      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchCommisions() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service":{
              "name":"underwriting",
              "version":"v1"
          },
          "resource":{
              "name":"commision",
              "version":"v1"
          },
          "action":{
              "name":"listEntityCommissions",
              "version":"v1"
          },  
          "data":{
                  
              }
      }
      let response = await call_api_v2(body, config);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchCommisionDetails(systemEntityCommisionRef) {
  return new Promise(async function (resolve, reject) {
    try {
          const body = {
              "service":{
                  "name":"underwriting",
                  "version":"v1"
              },
              "resource":{
                  "name":"commision",
                  "version":"v1"
              },
              "action":{
                  "name":"fetchCommissionDetails",
                  "version":"v1"
              },  
              "data":{      
                "systemEntityCommisionRef": systemEntityCommisionRef         
           }
          }
      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}

async function addRecommendation(values, quotationRequestRef) {
  return new Promise(async function (resolve, reject) {
    console.log("ooo", {values, quotationRequestRef})
    try {

      const body = {
        service: { name: "underwriting", version: "v1" },
        resource: { name: "quotation", version: "v1" },
        action: { name: "addReccommendation", version: "v1" },
        data: {
          quotationRequestRef: quotationRequestRef,
          remarks: values.remarks,
          reccommendationLevel: parseInt(values.recommendationLevel),
          productSystemRef: values.productSystemRef,
          coverDetails: {
            period: values.cover,
            coverStartDate: values.coverStartDate
          },
          additionalBenefits: values.additionalBenefits || [],
        },
      };

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function sendClientHelpQuotation(quotationRequestRef) {
  return new Promise(async function (resolve, reject) {
    try {

      const body = {"service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"quotation","version":"v1"},
        "action":{"name":"sendReccommendation","version":"v1"},
        "data":{
            "quotationRequestRef": quotationRequestRef
        }
        };

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function acceptOrRejectQuotation(quotationRequestRef, status) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        service: { name: "underwriting", version: "v1" },
        resource: { name: "quotation", version: "v1" },
        action: { name: "acceptOrRejectQuotationRequest", version: "v1" },
        data: {
          quotationRequestRef: quotationRequestRef,
          status: status,
        },
      };

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function sendRecommendation(quotationRequestRef) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        service: { name: "underwriting", version: "v1" },
        resource: { name: "quotation", version: "v1" },
        action: { name: "sendReccommendation", version: "v1" },
        data: {
          quotationRequestRef: quotationRequestRef,
        },
      };

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchGuestQuotationDetails(systemQuotationRef) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"underwriting","version":"v1"},
        "resource":{"name":"quotation","version":"v1"},
        "action":{"name":"getQuotationDetails","version":"v1"},
        "data":{
            "quotationRequestRef": systemQuotationRef
        }
        }
      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchWalletDetails() {
  return new Promise(async function (resolve, reject) {
    try {
          const body = {
                "service":{
                    "name":"entity",
                    "version":"v1"
                },
                "resource":{
                    "name":"wallet",
                    "version":"v1"
                },
                "action":{
                    "name":"fetchEntityWallets",
                    "version":"v1"
                },  
                "data":{
                    
                    }
            }
      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("fetchign wallet details", response)
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchWalletTransactions(accountNumber) {
  return new Promise(async function (resolve, reject) {
    try {
          const body = {
            "service":{
                "name":"entity",
                "version":"v1"
            },
            "resource":{
                "name":"wallet",
                "version":"v1"
            },
            "action":{
                "name":"fetchWalletTransactions",
                "version":"v1"
            },  
            "data":{
                    "accountNumber": accountNumber,
                }
        }
      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchIntermediaryCommisions(number = 1) {
  return new Promise(async function (resolve, reject) {
    try {
          const body = {
          "service":{"name":"intermediary","version":"v1"},
          "resource":{"name":"commision","version":"v1"},
          "action":{"name":"fetchIntermediaryCommisions","version":"v1"},
            "data":
            {
              "pageNumber": number
            }
          }  

      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchIntermediaryCommisionDetails(systemEntityCommisionRef) {
  return new Promise(async function (resolve, reject) {
    try {
          const body = {
            "service":{"name":"intermediary","version":"v1"},
            "resource":{"name":"commision","version":"v1"},
            "action":{"name":"fetchCommissionDetails","version":"v1"},
              "data":
              {
                 "systemEntityCommisionRef": systemEntityCommisionRef
              }
          }
          
      let response = await call_api_v2(body, CONST.CONFIG);
     
      return resolve(response);  
    } catch (err) {
      return reject(err);
    }
  });
}


async function sendInvoice(invoiceSystemRef) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"invoice","version":"v1"},
        "action":{"name":"sendInvoiceToClient","version":"v1"},
          "data": {
          "invoiceSystemRef": invoiceSystemRef
          }
        };

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchIntermediarypolicies() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"policies","version":"v1"},
        "action":{"name":"fetchIntermediarypolicies","version":"v1"},
          "data":
          {
            // "querryOptions":{
            //     "page":1
            // }
          }
        }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function sendQuotation() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {};

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

 
async function registerIntermediary({email, category, ira_code, names}) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"entity","version":"v1"},
        "resource":{"name":"intermediary","version":"v1"},
        "action":{"name":"registration","version":"v1"},
          "data": {
          "primaryEmail": email,
          "licenseNumber": ira_code,
          "category": category,
          "intermediaryUser":{
                  "names": names,
                  "email": email
          }
          }
        } 
      console.log("RESPONSE REGISTER===123456")
      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("RESPONSE REGISTER===", response)
      return resolve(response);
    } catch (err) {
      console.log("ERROR==", err)
      return reject(err);
    }
  });
}


async function verifyOTP(values) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{
              "name":"user",
              "version":"v1"
          },
          "resource":{
              "name":"registration",
              "version":"v1"
          },
          "action":{
              "name":"registrationValidation",
              "version":"v1"
          },  
          "data":{
                  "registrationId": values.regId,
                  "registrationCode": values.code
              }
      }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function createIntermediary(regId, names, credentials) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service":{
              "name":"user",
              "version":"v1"
          },
          "resource":{
              "name":"registration",
              "version":"v1"
          },
          "action":{
              "name":"createUser",
              "version":"v1"
          },  
          "data":{
                  "registrationId": regId,
                  "username": credentials.username,
                  "password": credentials.password,
                  // "contacts": "0708801050"
              }  
      }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
} 

async function fetchIntermediaryProfile() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"profile","version":"v1"},
        "action":{"name":"details","version":"v1"},
          "data": {
          }
        } 

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function updateIntermediaryProfile(values) {
  return new Promise(async function (resolve, reject) {
    try {

      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"profile","version":"v1"},
        "action":{"name":"update","version":"v1"},
          "data": {
            "intermediaryLocation": values.intermediaryLocation,
            "kraPin": values.kraPin,
            "profileImage": values.profileImage,
            "profileType": values.profileType,
            "contacts": values.contacts,
            "description": values.description,
            "intermediaryNames": values.intermediaryNames,
          }
        }  

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

 
async function updateIntermediaryKyc(values) {
  console.log("kyc values== server", values.socialMedia)
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"kyc","version":"v1"},
        "action":{"name":"update","version":"v1"},
          "data": {
            "kyc":{
                // "documents": values.documents,
                // "directors": values.directors,
                // "pobox": values.pobox,
                // "country": values.country,
                // "city": values.city,
                // "socialMedia": values.socialMedia
                ...values,
                socialMedia: values.socialMedia
            }
          }
        } 

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function loginIntermediary(values) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service": {
              "name": "user",
              "version": "v1"
          },
          "resource": {
              "name": "auth",
              "version": "v1"
          },
          "action": {
              "name": "login",
              "version": "v1"
          },
          "data": {
              "username": values.username,
              "password": values.password,
              "loginDevice": {}
          }
      } 

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("response login===", response)
       sessionStorage.setItem("token", response.accessToken);
       
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function forgotPasswordRequest(values) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service": {
              "name": "user",
              "version": "v1"
          },
          "resource": {
              "name": "auth",
              "version": "v1"
          },
          "action": {
              "name": "forgotPasswordRequest",
              "version": "v1"
          },
          "data": {
              "username": values.username
          }
      }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function forgotPasswordValidation(code, ref) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service": {
              "name": "user",
              "version": "v1"
          },
          "resource": {
              "name": "auth",
              "version": "v1"
          },
          "action": {
              "name": "forgotPasswordValidation",
              "version": "v1"
          },
          "data": {
              "forgotPasswordSystemRef": ref,
              "code": code
          }
      }

      let response = await call_api_v2(body, CONST.CONFIG);
   
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function resetPasswordRequest(values) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service": {
              "name": "user",
              "version": "v1"
          },
          "resource": {
              "name": "auth",
              "version": "v1"
          },
          "action": {
              "name": "resetPasswordRequest",
              "version": "v1"
          },
          "data": {
              "forgotPasswordSystemRef": values.passRef,
              "newPassword": values.newPassword
          }
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function FetchInsuranceClasses(){

  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service": {
              "name": "client",
              "version": "v1"
          },
          "resource": {
              "name": "classes",
              "version": "v1"
          },
          "action": {
              "name": "fetch",
              "version": "v1"
          },
          "data": {
              
          }
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchAllUnderwriters() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"underwriter","version":"v1"},
        "action":{"name":"fetchAllunderwriters","version":"v1"},
          "data": {
          }  
        }  

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function configureUnderwriter(values) {
  console.log("CONFIGURE UNDERWRITER===", values)
  return new Promise(async function (resolve, reject) {
    try {
      const body =   {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"underwriter","version":"v1"},
        "action":{"name":"config","version":"v1"},
          "data": {
            "underwriterSystemRef": values.underwriterSystemRef,
                "isEnabled": values.isEnabled,
                "settlementChannel": values.settlementChannel,
                "settlementChannelDetails": values.settlementChannelDetails,
                "internalUnderwriterRef": values.internalUnderwriterRef,
                "emails": values.emails, //array
                "allowedToCreateProducts": values.allowedToCreateProducts,
                "minimumSettlementAmount": values.minimumSettlement,
                "allowedInsurances": values.insuranceClasses,
                "settlementType": values.channelType,
                "settlementFrequency": values.settlementFrequency,
          }
        }  

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchConfiguredUnderwriters() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
          "service":{"name":"intermediary","version":"v1"},
          "resource":{"name":"underwriter","version":"v1"},
          "action":{"name":"myunderwritersconfigs","version":"v1"},
            "data": {
            } 
          }  
      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchRenewalSummary() {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
      "service":{"name":"intermediary","version":"v1"},
      "resource":{"name":"renewal","version":"v1"},
      "action":{"name":"summary","version":"v1"},
        "data": {      
        } 
      }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchPolicyDetails(policySystemRef) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{
        "name":"underwriting",
        "version":"v1"
        },
        "resource":{"name":"policy","version":"v1"},
        "action":{"name":"getPolicyDetails","version":"v1"},
        "data":{
            "policySystemRef": policySystemRef
        }
    }
      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchRenewals(values) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"policy","version":"v1"},
        "action":{"name":"renewalRange","version":"v1"},
          "data": {
              "start": values.startDate,
              "end": values.endDate
          } 
        }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchRenewalsMilestone(value) {
  return new Promise(async function (resolve, reject) {
    try {
      const body = {
        "service":{"name":"intermediary","version":"v1"},
        "resource":{"name":"policy","version":"v1"},
        "action":{"name":"renewalMilestone","version":"v1"},
          "data": {
            milestone:value
          }
        }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function register_valuer(values){
  return new Promise(async function (resolve, reject){
    try{
      const body={
        "service":{"name":"underwriting", "version":"v1"},
        "resource":{"name":"valuation", "version":"v1"},
        "action":{"name":"addValuerPanel", "version":"v1"},
        "data":values
      }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    }catch(err){
      return reject(err)
    }
  })
}

async function register_valuer_config(values){
  return new Promise(async function (resolve, reject){
    try{
      const body={
        "service":{"name":"underwriting", "version":"v1"},
        "resource":{"name":"valuation", "version":"v1"},
        "action":{"name":"valuationConfig", "version":"v1"},
        "data":values
      }

      let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    }catch(err){
      return reject(err)
    }
  })
}

async function get_valuer_panel(){
  return new Promise(async function (resolve, reject){
    try{
const body={
  "service":{"name":"underwriting", "version":"v1"},
  "resource":{"name":"valuation", "version":"v1"},
  "action":{"name":"getEntityValuerPanel", "version":"v1"},
  "data":{}
}
let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    }catch(error){
      return  reject(error)
    }
  })
}

async function product_valuation_config(values){
  return new Promise(async function (resolve, reject){
    try{
const body={
  "service":{"name":"underwriting", "version":"v1"},
  "resource":{"name":"product", "version":"v1"},
  "action":{"name":"updateProductValuationConfig", "version":"v1"},
  "data":values
}
let response = await call_api_v2(body, CONST.CONFIG);

      return resolve(response);
    }catch(error){
      return  reject(error)
    }
  })
}

async function fetch_product_valuation_config(){
  return new Promise(async function (resolve, reject){
    try{
  const body= {
    "service":{
        "name":"underwriting",
        "version":"v1"
    },
    "resource":{
        "name":"valuation",
        "version":"v1"
    },
    "action":{
        "name":"listEntityValuationConfigs",
        "version":"v1"
    },  
    "data":{
   
        }
}
  let response = await call_api_v2(body, CONST.CONFIG);

        return resolve(response);
      }catch(error){
        return  reject(error)
      }
    })
  }



async function addPanelRequest(values){
  console.log("adding panel requests", values)
  return new Promise(async function (resolve, reject){
    try{
  const body= {
        "service":{
            "name":"intermediary",
            "version":"v1"
        },
        "resource":{
            "name":"panel",
            "version":"v1"
        },
        "action":{
            "name":"addtoPanelRequest",
            "version":"v1"
        },  
        "data":{

            "underwriterSystemRef": values.underwriterSystemRef,
            "requestRemarks": values.requestRemarks
        }
    }
  let response = await call_api_v2(body, CONST.CONFIG);

        return resolve(response);
      }catch(error){
        return  reject(error)
      }
    })
}


async function listMyRequests(values){
  return new Promise(async function (resolve, reject){
    try{
      const body= {
          "service":{
              "name":"intermediary",
              "version":"v1"
          },
          "resource":{
              "name":"panel",
              "version":"v1"
          },
          "action":{
              "name":"myRequests",
              "version":"v1"
          },  
          "data":{

          }
      }

      let response = await call_api_v2(body, CONST.CONFIG);
      console.log("LISTMYREQUEST", response)

        return resolve(response);
      }catch(error){
        return  reject(error)
      }
    })
}


async function listMyUnderwriters(values){
  return new Promise(async function (resolve, reject){
    try{
  const body= {
      "service":{
          "name":"intermediary",
          "version":"v1"
      },
      "resource":{
          "name":"panel",
          "version":"v1"
      },
      "action":{
          "name":"myUnderwriters",
          "version":"v1"
      },  
      "data":{

      }
  }

  let response = await call_api_v2(body, CONST.CONFIG);

        return resolve(response);
      }catch(error){
        return  reject(error)
      }
    })
}




async function addProductLiabilites(values){
  console.log("adding liabilites", values)
  return new Promise(async function (resolve, reject){
    try{
  const body= {
    "service":{ "name":"underwriting", "version": "v1"},
    "resource": {"name":"product", "version":"v1"},
    "action": {"name": "addProductLiability", "version": "v1"},
    "data": {
        "productSystemRef":  values.productSystemRef,
        "liabilities": values.liabilities
    }
  }

  let response = await call_api_v2(body, CONST.CONFIG);
  console.log("LIA RES", response)

        return resolve(response);
      }catch(error){
        return  reject(error)
      }
    })
}


async function addProductExcess(values){
  console.log("adding liabilites", values)
  return new Promise(async function (resolve, reject){
    try{
  const body= {
  "service":{"name":"underwriting","version":"v1"},
  "resource":{"name":"product","version":"v1"},
  "action":{"name":"addProductExcess","version":"v1"},
  "data":{
      "productSystemRef": values.productSystemRef,
      "productExcess":{
          "name": values.name,
          "description": values.description,
          "excessValueType": values.excessValueType  ,//"PERCENTAGE","FIXED"
          "excessType": values.excessType,    //"MANDATORY","VOLUNTARY"
          "value": values.value,
          "basedOn":  values.basedOn   //"PREMIUM","SUM_INSURED","LIMIT","NONE"
      }
  }         
        
  } 

  let response = await call_api_v2(body, CONST.CONFIG);


        return resolve(response);
      }catch(error){
        return  reject(error)
      }
    })
}



async function fetchUnderwriterDetails(underwriterSystemRef){
  return new Promise(async function (resolve, reject){
    try{
  const body= {
    "service":{ "name":"underwriting", "version": "v1"},
    "resource": {"name":"underwriter", "version":"v1"},
    "action": {"name": "getUnderwriterDetails", "version": "v1"},
    "data": {
        "underwriterSystemRef": underwriterSystemRef    }

}
  let response = await call_api_v2(body, CONST.CONFIG);

        return resolve(response);
      }catch(error){
        return  reject(error)
      }
    })
  }

  
async function sendQuotationToClient(systemQuotationRef){
  console.log("Sending quote to client", systemQuotationRef)
  return new Promise(async function (resolve, reject){
    try{
  const body= {
    "service":{
        "name":"underwriting",
        "version":"v1"
    },
    "resource":{
        "name":"quotation",
        "version":"v1"
    },
    "action":{
        "name":"sendQuotationtoClient",
        "version":"v1"
    },  
    "data":{

        "systemQuotationRef": systemQuotationRef
    }
}
  

    let response = await call_api_v2(body, CONST.CONFIG);


       return resolve(response);
      }catch(error){
        return  reject(error)
      }
    })
}


async function createSettlementConfig(values) {
  return new Promise(async (resolve, reject) => {
    try {
      const body = {
        service: {
          name: "underwriting",
          version: "v1"
        },
        resource: {
          name: "settlement",
          version: "v1"
        },
        action: {
          name: "createSettlementConfig",
          version: "v1"
        },
        data: {
          accountNumber: values.accountNumber,
          settlementConfigFrequency: values.settlementConfigFrequency,//"EOD", // 'EOD', 'WEEKLY', 'MONTHLY', 'THRESHOLD'
          settlementConfigThreshold:  values.settlementConfigThreshold || 0,
          settlementConfigChannel: values.settlementConfigChannel, // 'mpesaNumber', 'mpesaPaybil', 'bank'
          settlementConfigChannelDetails: {
            PhoneNumber: values.PhoneNumber // "254725596227"
          }
        }
      };

    
      const response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function getSettlementConfig(settlementConfigSystemRef) {
  return new Promise(async (resolve, reject) => {
    try {
      const body =     {
      "service":{
      "name":"underwriting",
      "version":"v1"
      },
      "resource":{
      "name":"settlement",
      "version":"v1"
      },
      "action":{
      "name":"getSettlementConfig",
      "version":"v1"
      },
      "data":{

        "settlementConfigSystemRef": settlementConfigSystemRef
      }
      }

      const response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function getSettlementConfigs() {
  return new Promise(async (resolve, reject) => {
    try {
      const body = {
        service: {
          name: "underwriting",
          version: "v1"
        },
        resource: {
          name: "settlement",
          version: "v1"
        },
        action: {
          name: "entitySettlementConfigs",
          version: "v1"
        },
        data: {}
      };

      const response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function requestSettlement(values) {
  return new Promise(async (resolve, reject) => {
    try {
      const body = {
        "service":{
        "name":"underwriting",
        "version":"v1"
        },
        "resource":{
        "name":"settlement",
        "version":"v1"
        },
        "action":{
        "name":"requestSettlement",
        "version":"v1"
        },
        "data":{
          "amount": values.amount,
          "drEntityAccount": values.drEntityAccount,
          "externalSettlementReference": values.externalSettlementReference,
          "settlementRemarks": values.settlementRemarks

        }
      }

      const response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchSettlementRequests() {
  return new Promise(async (resolve, reject) => {
    try {
      const body =   {
      "service":{
      "name":"underwriting",
      "version":"v1"
      },
      "resource":{
      "name":"settlement",
      "version":"v1"
      },
      "action":{
      "name":"settlementRequests",
      "version":"v1"
      },
      "data":{ }
      }


      const response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}


async function fetchSettlementRequestDetails(settlementRequestSystemRef) {
  return new Promise(async (resolve, reject) => {
    try {
      const body =   {
        "service":{
        "name":"underwriting",
        "version":"v1"
        },
        "resource":{
        "name":"settlement",
        "version":"v1"
        },
        "action":{
        "name":"settlementReqDetails",
        "version":"v1"
        },
        "data":{
          "settlementRequestSystemRef":  settlementRequestSystemRef
        }
        }

      const response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}

async function fetchSettlementStats() {
  return new Promise(async (resolve, reject) => {
    try {
      const body =   {
        "service":{
        "name":"underwriting",
        "version":"v1"
        },
        "resource":{
        "name":"settlement",
        "version":"v1"
        },
        "action":{
        "name":"fetchSettlementStatusStats",
        "version":"v1"
        },
        "data":{
          // "settlementRequestSystemRef":  settlementRequestSystemRef
        }
        }

      const response = await call_api_v2(body, CONST.CONFIG);
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
}





export {
  config,
  api_url,
  base_url,
  file_url,
  call_api_v2,
  register,
  login,
  manage_appointment,
  verify,
  check_kyc,
  verify_email,
  forgot_password,
  get_intermediary_type,
  upload_company_logo,
  get_professions_list,
  submitCredentials,
  upload_individual_agent_kyc_details,
  upload_company_agent_kyc_details,
  upload_directors,
  get_requests,
  get_quotation_requests,
  get_dashboard_summary,
  get_professions,
  update_professions,
  call_api,
  upload_api,
  set_location,
  request_underwriter,
  get_underwriters_requests,
  get_subclass,
  get_subclass_products,
  get_asset_requirements,
  get_product_summary,
  view_quotation_request,
  create_guest_quotation_recommendation,
  sendQuotationToGuestClient,
  get_all_quotations,
  create_quotation,
  create_client_quotation,
  list_client_quotation,
  list_client_quotation_risks,
  list_guest_client_recommendations,
  list_cover_types,
  view_a_quotation,
  send_quotation,
  fetch_wallet_info,
  fetch_account_transactions,
  fetch_my_underwriters,
  get_policies,
  get_policy,
  get_transactions,
  fetch_claim_types,
  fetch_form,
  fetch_commission_account,
  view_policy,
  generate_claim_ref,
  fetch_all_claims,
  report_claim,
  fetch_claim_form,
  fetch_claim_details,
  fetch_poliy_claims,
  upload_individual_claim_field,
  make_claim_form,
  send_claim,
  // fetch_notifications,
  validate_reset_token,
  reset,
  create_an_appointment,
  fetch_appointments,
  fetch_appointment_details,
  close_appointment,
  update_appointment_new_status,
  list_usmg_roles,
  add_usmg_roles,
  list_system_resources,
  list_role_grants,
  revoke_resource,
  grant_resource,
  grant_permissions,
  remove_permissions,
  view_role_details,
  create_department,
  list_departments,
  department_details,
  list_security_context,
  list_users,
  create_user,
  view_user,
  list_user_groups,
  create_user_group,
  get_user_details,
  add_user_to_group,
  create_context,
  get_context,
  get_reviews,
  // chat_login,
  get_conversations,
  add_chat_conversation,
  list_clients,
  chat_message_conversations,
  get_chat_groups,
  create_chat_groups,
  add_chat_users_to_group,
  fetch_claim_summary,
  get_relationship_managers,
  get_sales_rep,
  assign_relationship_manager,
  add_sales_rep,
  get_rep_details,
  list_pending_claims,
  approve_pending_claims,
  list_fees,
  add_fees,
  list_taxes,
  add_taxes,
  list_leads,
  rm_details,
  lead_details,
  list_domains,
  add_domains,
  assign_rm_lead,
  assign_lead_sales_rep,
  close_lead,
  list_open_leads,
  incentify_lead,
  create_lead_quotation,
  assign_open_lead,
  listSettlement,
  listConfigs,
  createConfig,
  listChannels,
  createChannel,
  list_tax_category,
  getFeeDetails,
  calculateFee,
  getTaxDetails,
  calculateTax,
  accept_quotation_request,
  reject_quotation_request,
  fetch_risk_form,
  post_risk_form,
  post_client_risk_form,
  list_recommendations,
  add_recommendations,
  list_risks,
  list_product_benefits,
  list_special_codes,
  recommendation_details,
  remove_recommendation,
  add_product_benefits,
  add_client_product_benefits,
  fetch_products_by_underwriter,
  add_risk_to_recommendation,
  send_quotation_request,
  remove_product_benefits,
  listSchemes,
  checkPin,
  createScheme,
  schemeDetails,
  risk_details,
  risk_guest_details,
  addSchemeDocument,
  listSchemeDocuments,
  addSchemeGroup,
  listSchemeGroup,
  schemeGroupDetails,
  addSchemeGroupMember,
  removeSchemeGroupMember,
  listGroupMembers,
  getMemberDetails,
  negotiateRate,
  fetch_rates,
  view_client_quotation,
  create_product_underwriter,
  create_credentials,
  create_dmvic,
  create_product_benefit,
  create_rate,
  list_rates,
  create_product,
  update_product,
  list_commissions,
  list_benefit_types,
  fetch_my_underwriters_v2,
  list_intermediary_underwriters,
  list_charges,
  list_dmvics,
  fetch_product_benefits,
  list_my_products,
  list_subclass,
  attach_product_benefit,
  fetch_product_details,
  list_categories,
  configure_policy_no,
  create_product_excess,
  create_product_liability,
  addProductLiabilites,
  create_payment,
  update_policy_config,
  issue_motor_cert,
  publish_product,
  setup_product_accounting_config,
  update_product_accounting_config,
  setup_product_requirements,
  setup_product_pricing,
  setup_product_tnc,
  list_plans,
  list_policies,
  upload_policy,
  fetchEntitySystemQuotations,
  quotationDetails,
  listEntityCommissions,
  fetchCommissionDetails,
  create_client_direct_quoation,
  fetchClientQuotations,
  fetchClientQuotationDetails,
  complete_client_direct_quoation,
  request_payment_direct_quoation,
  fetchCommisions,
  fetchInvoices,
  fetchCommisionDetails,
  fetchInvoiceDetails,
  get_client_quotation_requests,
  addRecommendation,
  acceptOrRejectQuotation,
  sendRecommendation,
  fetchGuestQuotationDetails,
  sendClientHelpQuotation,
  fetchWalletDetails,
  fetchWalletTransactions,
  fetchIntermediaryCommisionDetails,
  fetchIntermediaryCommisions,
  sendInvoice,
  sendQuotation,
  fetchIntermediarypolicies,
  registerIntermediary,
  verifyOTP,
  createIntermediary,
  // loginIntermediary,
  fetchIntermediaryProfile,
  updateIntermediaryProfile,
  updateIntermediaryKyc,
  resetPasswordRequest,
  forgotPasswordValidation,
  forgotPasswordRequest,
  fetchAllUnderwriters,
  configureUnderwriter,
  fetchConfiguredUnderwriters,
  fetchRenewalSummary,
  fetchPolicyDetails,
  fetchRenewals,
  fetchRenewalsMilestone,
  FetchInsuranceClasses,
  fetch_benefit_categories,
  register_valuer,
  register_valuer_config,
  get_valuer_panel,
  product_valuation_config,
  listMyRequests,
  listMyUnderwriters,
  addPanelRequest,
  fetch_product_valuation_config,
  list_undewriter_products,
  fetchUnderwriterDetails,
  addProductExcess,
  sendQuotationToClient,
  test_product_excess,
  createSettlementConfig,
  getSettlementConfig,
  getSettlementConfigs,
  fetchSettlementRequestDetails,
  requestSettlement,
  fetchSettlementRequests,
  fetchSettlementStats
};
